import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from './../../environments/environment';
import { RestClient } from './rest.client';
import { Laboratory } from './../models/laboratory';
import { Address } from './../models/address';
import { Person } from './../models/person';

@Injectable({
  providedIn: 'root'
})
export class LaboratoryService extends RestClient {

	serverUrl: string;
	domainLink: string = "api/laboratory/";
	
	constructor(public http:HttpClient) {
		super(http);
		this.serverUrl = environment.serverUrl;
	}
	
	registerLaboratory(data:any){
		return this.http.post(this.serverUrl+this.domainLink+"reg", data);
	}
	
	identifyLaboratory(laboratory:Laboratory){
		return this.http.post(this.serverUrl+this.domainLink+"initChangePass", laboratory);
	}
	
	getPendingLaboratories(filter:any){
		return this.http.post(this.serverUrl+this.domainLink+"pending", filter, { headers: this.getHeaders() });
	}
	
	searchLaboratories(filter:any){
		return this.http.post(this.serverUrl+this.domainLink+"search", filter, { headers: this.getHeaders() });
	}
	
	verifyLaboratoryReg(data:any){
		return this.http.post(this.serverUrl+this.domainLink+"verify", data, { headers: this.getHeaders() });
	}
	
	getLaboratory(laboratoryId){
		return this.http.get(this.serverUrl+this.domainLink+"getLaboratory/"+laboratoryId, { headers: this.getHeaders() });
	}
	
	getCurrentLaboratory(){
		return this.http.get(this.serverUrl+this.domainLink+"getCurrentLaboratory", { headers: this.getHeaders() });
	}
	
	participateEvent(data:any){
		return this.http.post(this.serverUrl+this.domainLink+"participateEvent", data, { headers: this.getHeaders() });
	}
	
	participateEventV2(data:any){
		return this.http.post(this.serverUrl+this.domainLink+"participateEventV2", data, { headers: this.getHeaders() });
	}
	
	updateParticipantInstrument(data:any){
		return this.http.post(this.serverUrl+this.domainLink+"updateParticipantInstrument", data, { headers: this.getHeaders() });
	}
	
	resetLaboratoryPassword(laboratory:Laboratory){
		return this.http.post(this.serverUrl+this.domainLink+"resetLaboratoryPass", laboratory, { headers: this.getHeaders() });
	}
	
	updateLaboratory(laboratory:Laboratory){
		return this.http.post(this.serverUrl+this.domainLink+"updateLaboratory", laboratory, { headers: this.getHeaders() });
	}
	updateAddress(address:Address){
		return this.http.post(this.serverUrl+this.domainLink+"updateAddress", address, { headers: this.getHeaders() });
	}
	updatePersonnels(personnels:Person[]){
		return this.http.post(this.serverUrl+this.domainLink+"updatePersonnels", {'personnels':personnels}, { headers: this.getHeaders() });
	}
	addInstrument(data:any){
		return this.http.post(this.serverUrl+this.domainLink+"addInstrument", data, { headers: this.getHeaders()});
	}
	addNewInstrument(data:any){
		return this.http.post(this.serverUrl+this.domainLink+"addNewInstrument", data, { headers: this.getHeaders()});
	}
	addNewReagent(data:any){
		return this.http.post(this.serverUrl+this.domainLink+"addNewReagent", data, { headers: this.getHeaders()});
	}
}
